<script>
import CardAmount from './card-amount'

export default {
  el: '#product-detail-amounts',
  components: { CardAmount }
}
</script>
